import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

export async function GetLoginActivity(params) {
  const res = await api.get(routes.GET_USER_LOGIN_ACTIVITY, { params: params });

  return res;
}
